/**
 * Normalise an email for Google Ads enhanced conversion matching (gtag 'user_data').
 *
 * Match rate is the whole point: Google matches against the normalised form of the address the
 * user gave Google, so "Shaun.X+ads@Gmail.com " must come out as "shaunx@gmail.com" or the
 * conversion silently fails to match. Rules (Google's own): trim, lowercase, and for
 * gmail.com/googlemail.com ONLY strip dots from the local part and drop any +suffix — other
 * providers treat dots as significant, so they must be left alone.
 *
 * Pass the RESULT to gtag('set', 'user_data', {email}) unhashed — gtag SHA-256-hashes it itself;
 * pre-hashing double-hashes and produces a permanent, silent 0% match rate.
 */
export function normalizeEmailForAdsMatching(email: string | null | undefined): string | null {
    const trimmed = (email || '').trim().toLowerCase();
    const at = trimmed.lastIndexOf('@');
    if (at < 1) return trimmed || null;

    let local = trimmed.slice(0, at);
    const domain = trimmed.slice(at + 1);
    if (domain === 'gmail.com' || domain === 'googlemail.com') {
        local = local.replace(/\./g, '').replace(/\+.*$/, '');
    }
    return local ? `${local}@${domain}` : null;
}

/** Set enhanced-conversion user data on the Google tag — call immediately before the conversion
 *  event. A no-op without gtag or a usable email. Consent Mode gates the actual transmission:
 *  ad_user_data is 'denied' for UK/EEA/CH visitors until the CMP grants it, and gtag itself
 *  withholds user_data while denied — no extra gating needed here. */
export function setAdsUserData(email: string | null | undefined): void {
    const gtag = (window as any).gtag;
    const normalized = normalizeEmailForAdsMatching(email);
    if (typeof gtag === 'function' && normalized) {
        gtag('set', 'user_data', {email: normalized});
    }
}
